import styled from "@emotion/styled";


export const Flex = styled("div")(({ theme }) => ({
    display: "flex" ,
}));